export { default } from './LazyTeacherAgreement';
